import React, { useState, useContext, useEffect } from 'react'
import UserContext from '../contexts/UserContext'
import { useFormik } from 'formik'
import { Link, useNavigate } from 'react-router-dom'
import { Login, ResendSMSCode, VerifySMSCode } from 'helpers/api'
import localforage from 'localforage'
import * as yup from 'yup'
import classNames from 'classnames'
import VisibleEye from '../assets/visibleEye.svg'
import InvisibleEye from '../assets/invisibleEye.svg'
import handlogohome from '../assets/handlogohome.svg'
import logoSignup from '../assets/logoMyEasy.svg'
import LogoConatiner from './signUpContainer/logoContainer'
import imageLoginMobile from '../assets/imageLoginMobile.svg'
import newImageLogin from '../assets/newImageLogin.webp'
import VerifCode from './verifCode'
import LanguageIcon from '../assets/languageSwitcherIcon.svg'
import { useTranslation } from 'react-i18next'
import ModalLanguageSwitcher from 'components/ModalLanguageSwitcher'

const LoginContainer: React.FC = () => {
  const {user, setUser } = useContext(UserContext)
  const navigate = useNavigate()
  const [hasError, setHasError] = useState(false)
  const [hasNotActive,setHasNotActive] = useState(false)
  const [email, setEmail]=useState('')
  const [password, setpassword]=useState('')
  const [canResendOnce, setCanResendOnce]=useState(true)
  const[errorCode, setErrorCode]=useState(false)
  const [userId, setUserId]=useState()
  const [prefixe, setPrefixe]=useState('')
  const [numero,setNumero] = useState('')
  const { t } = useTranslation()
  const [openModalLanguage, setOpenModalLanguage]= useState(false)


  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      saveEmail: false,
    },
    validationSchema: yup.object({
      email: yup
        .string()
        // .email('Votre adresse e-mail doit être valide (exemple@domain.com)')
        
        .required('Ce champ est requis')
        
        .matches(
          /^[^\s@]+@[^\s@]+\.(com|fr|net|org|tn|ci|[a-z]{2,})$/,
          'Votre adresse e-mail doit être valide (exemple@domain.com)'
        ),
      password: yup
        .string()
        .required('Ce champ est requis')
        .matches(
          /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d\s])[^\s]{8,16}$/,

          'Le mot de passe doit contenir au moins 8 caractères avec au moins 1 lettre, 1 chiffre et 1 caractère spécial.',
        ),
    }),
   

    onSubmit: async (values) => {
      try {
        const response: any = await Login({ email: values.email, password: values.password })
       
    
       
        setHasNotActive(response.msg === 'Account not activated yet')
        setpassword(values.password)
        setEmail(values.email)
    
        if (response?.success) {  
          setUser(response)
          await localforage.setItem('auth', JSON.stringify(response))
          navigate('/')
        } else if (response.code === 1005) {
            setUserId(response.userId)
            setPrefixe(response.prefix)
            setNumero(response.phone)
            setHasError(false)
            setHasNotActive(true)
            await ResendSMSCode(response.userId)

        }else 
        {
          setHasError(true)
        }
      } catch (err) {
        console.error('Erreur lors de la connexion:', err)
        setHasError(false)
      }
    },
  })

  useEffect(() => {
    const savedEmail = localStorage.getItem('savedEmail')

    if (savedEmail && formik.values.email !== savedEmail) {
      formik.setFieldValue('email', savedEmail)
    }
  }, [formik.values.saveEmail, formik.setFieldValue])

  useEffect(() => {
    if (formik.values.saveEmail) {
      localStorage.setItem('savedEmail', formik.values.email)
    } else {
      localStorage.removeItem('savedEmail')
    }
  }, [formik.values.saveEmail, formik.values.email])
  const [visible, setVisible] = useState(false)


   const handleVerifCodeSubmit= async(code:string)=>{
      if(!userId) {
        console.error('User ID non défini')
        return
      }
    try{
    const response: any = await VerifySMSCode( userId, code)
    if(!response.success)
      {
        setErrorCode(true)
        return
      } 
        const loginReponse: any = await Login({ email:email, password: password })
 
        if (loginReponse?.success) {  
          setUser(loginReponse)
          await localforage.setItem('auth', JSON.stringify(loginReponse))
          navigate('/')
        }else{
          setErrorCode(true)
        }

    } catch (err) {
        console.error('Erreur lors de la connexion:', err)
      }

  }

  const handleResendCodeSubmit= async() =>{
    if(!userId){return}

    try{
      if(canResendOnce)
      {
     const response = await ResendSMSCode(userId)
      setCanResendOnce(false)
    }
    
    }catch(error){
      console.error('Veuillez contacter notre service client sur : +33 7 45 89 60 62', error)

    }
  }

  return (

    <div className="flex w-full lg:flex-col-reverse lg:justify-center sm:justify-normal h-screen ">
     <div className=" w-[50%] lg:w-full lg:px-[16px] overflow-y-auto scrollbar-webkit ">
        <LogoConatiner retour={false} image={logoSignup} />
        {!hasNotActive 
        ?<div>
          <div className="mx-[20%] 2xl:mx-10 sm:mx-[0px] ">
            <div className="flex items-center mt-[60px] sm:mt-[20px]">
              <div
                className={classNames(
                  'sm:text-[25px] text-[30px] text-[#1D3A70] text-left sm:font-semibold font-bold sm:mt-[2px]'
                )}
              >
                Bonjour
              </div>
              <img src={handlogohome} className="w-6 h-6 ml-3" />
            </div>
            <div className="text-[#6B7280] text-[15px] font-normal text-left sm:mt-[10px] mt-2 font-sans ">
              Connectez-vous pour accéder à votre compte
            </div>

            <form
              className={classNames('grid grid-cols-1 sm:gap-2 gap-2 mt-5 sm:mt-0')}
              onSubmit={formik.handleSubmit}
            >
              <div className="h-[100px]">
                <input
                  className="bg-[#F9FAFB] px-[14px] py-4 rounded-xl w-full mt-4 placeholder:text-[#9CA3AF] text-[#5754E5]"
                  name="email"
                  placeholder="Adresse e-mail"
                  type="text"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur('email')}
                />
                {formik.errors.email && formik.touched.email && (
                  <div className="text-red-500 text-[14px] sm:text-[12px]">{formik.errors.email}</div>
                )}
              </div>

              <div className="relative h-[100px]">
                <input
                  className="bg-[#F9FAFB] px-[14px] py-4 rounded-xl w-full  placeholder:text-[#9CA3AF] text-[#5754E5]"
                  name="password"
                  placeholder="Mot de passe"
                  type={visible ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur('password')}
                  // autoComplete='off'
                />
                <img
                  src={ !visible ? InvisibleEye : VisibleEye}
                  alt={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  className={classNames( 'absolute top-4 right-4 w-6 h-6 cursor-pointer' )}
                  onClick={() => setVisible(!visible)}
                />
                
                {formik.errors.password && formik.touched.password && (
                  <div className="text-red-500 text-[14px] sm:text-[12px]">{formik.errors.password}</div>
                )}
              </div>
              <div className="flex justify-between">
                <div className="flex items-center gap-2 sm:gap-1">
                  <input
                    id="saveEmail"
                    name="saveEmail"
                    type="checkbox"
                    checked={formik.values.saveEmail}
                    onChange={formik.handleChange}
                    className="w-4 h-4 text-[#1D3A70] bg-[#F9FAFB] border-black rounded focus:ring-[#D8D0FF] dark:focus:ring-black  dark:ring-blackfocus:ring-2 cursor-pointer"
                  />
                  <label
                    htmlFor="saveEmail"
                    className="text-[12px] sm:text-[10px] text-[#333F51] font-semibold cursor-pointer"
                  >
                    Sauvegardez vos identifiants
                  </label>
                </div>

                <Link to="/forgotPassword" className="text-[14px] font-normal text-[#5754E5] ">
                  Mot de passe oublié ?
                </Link>
              </div>
              <div  className="text-red-500 text-center text-[14px]  h-14 ">
                {/* {message} */}

              {hasError ? (
                  <div>
                    Veuillez vérifier l&apos;exactitude de votre adresse <br /> e-mail ou de votre mot de passe.
                  </div>
                ) : ( hasNotActive ?
                ( <div>
                  
                  Votre compte n&apos;est pas encore activé. <br/>
                  Veuillez cliquer sur le lien de confirmation envoyé par email pour finaliser l&apos;activation. 
                </div>) 
                :
                ( <div></div>) 

                )} 

              </div>
              <div className="flex justify-center ">
                <button
                  type="submit"
                  value="Submit"
                  // disabled={!formik.isValid || formik.values.email === '' || formik.values.password === ''}
                  className={`text-white px-[14px] py-4 text-[15px] font-medium rounded-xl w-[80%]
                    ${!formik.isValid || formik.values.email === '' || formik.values.password === '' ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#4743C9]'}`}
                >
                  Se connecter
                </button>
              </div>
            </form>
          </div>
          
          <div className="flex items-center justify-center mt-5 pb-5">
            <span className="text-[13px] font-semibold text-[#333F51] pr-2">Vous n’avez pas de compte ?</span>
            <Link to="/signup" className="text-[13px] font-semibold text-[#5754E5] ">
              S’inscrire
            </Link>
          </div>

          <div className=' flex items-center justify-center gap-4 '>
            <img
              onClick={()=>setOpenModalLanguage(true)}
             className='cursor-pointer' 
             src={LanguageIcon} alt='Changer la langue'/>
            <div className='text-[#422EAE] cursor-default font-bold text-[12px]'>{t('languages.name')}</div>
          </div>
        </div>
 
        :
      <VerifCode
          handleVerifCodeSubmit={handleVerifCodeSubmit}
          handleResendCodeSubmit={handleResendCodeSubmit}
          // canResendOnce={canResendOnce}
          errorCode={errorCode}
          setErrorCode={setErrorCode}
          prefixe={prefixe}
          phone={numero}
          />
                  }
      </div>
    
        
  

      <img
        className={classNames(
           'hidden lg:p-8 sm:p-4 lg:block w-full  ',
        )}
        src={imageLoginMobile}
        alt="Connexion pour les utilisateurs MyEasyTransfer"
        loading="eager"
      />
      <img className=' lg:hidden w-[50%] object-cover h-screen '  src={newImageLogin} alt='Connexion pour les utilisateurs MyEasyTransfer' 
      loading="eager"
      />

      {openModalLanguage && <ModalLanguageSwitcher setIsOpen={setOpenModalLanguage}/>}
    </div>
  )
}
export default LoginContainer
